import { createSelector } from '@reduxjs/toolkit';
import { defaultUrls } from 'consts';
import { RootState } from 'types/store';

export const selectEnvironment = (state: RootState): Environment => {
    return state.environment;
};

export const selectEnvironmentApp = (state: RootState): AppEnvs => {
    return state.environment.app;
};

export const selectShowUnavailableStores = (state: RootState): boolean => {
    const value = state.environment.app.showUnavailableStores;
    return value !== undefined ? value === 'true' : true;
};

export const selectRedirectFulfillment = (state: RootState): string | undefined => {
    return state.environment.app.redirectFulfillment;
};

export const selectSellersIds = (state: RootState): string[] => {
    return state.environment.app.sellersIds;
};

export const selectIsChekOpex = (state: RootState): boolean => {
    return state.environment.app.is_chek_opex;
};

export const selectCurrency = (state: RootState): string => {
    return state.environment.app.currency;
};

export const selectMyAccountUrl = (state: RootState): string => {
    return state.environment.app.miCuentaUrl;
};

export const selectShopUrl = (state: RootState): string => {
    return state.environment.app.tiendaUrl;
};

//REACT_APP_DISABLE_CYBERSOURCE_COOKIE_TIME
export const selectCountry = createSelector([selectEnvironmentApp], (app): Country => {
    const country = app.country;
    return country === 'CL' || country === 'PE' ? country : 'CL';
});

export const selectURL = createSelector([selectEnvironmentApp, selectCountry], (app, country) => {
    return (key: keyof typeof defaultUrls.CL): string => {
        const defaultValue = defaultUrls[country as keyof typeof defaultUrls][key];
        const envValue = app[key];

        if (envValue) {
            return envValue;
        }

        if (defaultValue) {
            return defaultValue;
        }

        throw new Error(`Value not defined for ${country}.${key}`);
    };
});

export const selectOpexPaymentMethods = createSelector(
    [selectIsChekOpex],
    (isChekOpex): PaymentMethodName[] => {
        return isChekOpex
            ? ['RipleyCard', 'RipleyChek', 'Alignet', 'RipleyChekCard']
            : ['RipleyCard', 'Alignet', 'RipleyChekCard'];
    },
);

export const selectAnalyticsConfig = (state: RootState) => state.environment.analytics;

export const selectIsActiveLogSending = (state: RootState) =>
    state.environment.app.isActiveLogSending ?? false;

export const selectDisableCybersourceCookieTime = (state: RootState): number => {
    return state.environment.payments.disableCybersourceCookieTime;
};
